import { VeeCreateObject } from '@shared/interfaces/vee/vee-create-object.interface';

const baseMethods: VeeCreateObject[] = [
  { sortOrder: 1, title: 'enum.estimationmethod.controlmeter', method: 3, estimationMethod: 0 },
  { sortOrder: 2, title: 'enum.estimationmethod.sameasdaybefore', method: 1, estimationMethod: 0 },
  { sortOrder: 3, title: 'enum.estimationmethod.sameassevendaysbefore', method: 2, estimationMethod: 0 },
  { sortOrder: 4, title: 'enum.estimationmethod.sameas1monthbefore', method: 4, estimationMethod: 0 },
  { sortOrder: 5, title: 'enum.estimationmethod.ghostmeter', method: 5, estimationMethod: 0 },
  { sortOrder: 6, title: 'enum.estimationmethod.zerovaluemeteringpointdisconnected', method: 6, estimationMethod: 0 },
  { sortOrder: 7, title: 'enum.estimationmethod.zerovalueinsideday', method: 7, estimationMethod: 0 },
  { sortOrder: 8, title: 'enum.estimationmethod.zerovaluemeterchange', method: 18, estimationMethod: 0 },
];

const machineLearningMethod: VeeCreateObject =
  { sortOrder: 9, title: 'enum.estimationmethod.advancedvee', method: 13, estimationMethod: 0 };

export function getVeeAvailableEstimationMethods(machineLearningEnabled: boolean): VeeCreateObject[] {
  return machineLearningEnabled
    ? [...baseMethods, machineLearningMethod]
    : baseMethods;
}
